module.exports = __webpack_public_path__ + "static/media/thunderstorm 11d.8d5deced.png";